import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sk',
  months: [
    'január',
    'február',
    'marec',
    'apríl',
    'máj',
    'jún',
    'júl',
    'august',
    'september',
    'október',
    'november',
    'december',
  ],
  monthsShort: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
  weekdays: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota'],
  weekdaysMin: ['n', 'p', 'u', 's', 'š', 'p', 's'],
  weekdaysShort: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D. M. YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY, HH:mm',
    'LLL-Y': 'D. MMMM, HH:mm',
    LLLL: 'dddd D. MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D. MMMM, HH:mm',
    l: 'D. M. YYYY',
    'l-Y': 'D. M.',
    ll: 'D. M. YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. M. YYYY, HH:mm',
    'lll-Y': 'D. M., HH:mm',
    llll: 'ddd D. M. YYYY, HH:mm',
    'llll-Y': 'ddd D. M., HH:mm',
    'll-Y+w': 'ddd D. M.',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY, H:mm ([GMT]Z)',
  },
  meridiem: { am: 'dop.', pm: 'pop.', AM: 'dop.', PM: 'pop.' },
  past: {
    y: { one: 'pred %s r.', few: 'pred %s r.', many: 'pred %s r.', other: 'pred %s r.' },
    M: { one: 'pred %s mes.', few: 'pred %s mes.', many: 'pred %s mes.', other: 'pred %s mes.' },
    w: { one: 'pred %s týž.', few: 'pred %s týž.', many: 'pred %s týž.', other: 'pred %s týž.' },
    d: { one: 'pred %s d.', few: 'pred %s d.', many: 'pred %s d.', other: 'pred %s d.' },
    h: { one: 'pred %s h', few: 'pred %s h', many: 'pred %s h', other: 'pred %s h' },
    m: { one: 'pred %s min', few: 'pred %s min', many: 'pred %s min', other: 'pred %s min' },
    s: { one: 'pred %s s', few: 'pred %s s', many: 'pred %s s', other: 'pred %s s' },
  },
  future: {
    y: { one: 'o %s r.', few: 'o %s r.', many: 'o %s r.', other: 'o %s r.' },
    M: { one: 'o %s mes.', few: 'o %s mes.', many: 'o %s mes.', other: 'o %s mes.' },
    w: { one: 'o %s týž.', few: 'o %s týž.', many: 'o %s týž.', other: 'o %s týž.' },
    d: { one: 'o %s d.', few: 'o %s d.', many: 'o %s d.', other: 'o %s d.' },
    h: { one: 'o %s h', few: 'o %s h', many: 'o %s h', other: 'o %s h' },
    m: { one: 'o %s min', few: 'o %s min', many: 'o %s min', other: 'o %s min' },
    s: { one: 'o %s s', few: 'o %s s', many: 'o %s s', other: 'o %s s' },
  },
  pastLong: {
    y: { one: 'pred %s rokom', few: 'pred %s rokmi', many: 'pred %s roka', other: 'pred %s rokmi' },
    M: { one: 'pred %s mesiacom', few: 'pred %s mesiacmi', many: 'pred %s mesiaca', other: 'pred %s mesiacmi' },
    w: { one: 'pred %s týždňom', few: 'pred %s týždňami', many: 'pred %s týždňa', other: 'pred %s týždňami' },
    d: { one: 'pred %s dňom', few: 'pred %s dňami', many: 'pred %s dňa', other: 'pred %s dňami' },
    h: { one: 'pred %s hodinou', few: 'pred %s hodinami', many: 'pred %s hodinou', other: 'pred %s hodinami' },
    m: { one: 'pred %s minútou', few: 'pred %s minútami', many: 'pred %s minúty', other: 'pred %s minútami' },
    s: { one: 'pred %s sekundou', few: 'pred %s sekundami', many: 'pred %s sekundy', other: 'pred %s sekundami' },
  },
  futureLong: {
    y: { one: 'o %s rok', few: 'o %s roky', many: 'o %s roka', other: 'o %s rokov' },
    M: { one: 'o %s mesiac', few: 'o %s mesiace', many: 'o %s mesiaca', other: 'o %s mesiacov' },
    w: { one: 'o %s týždeň', few: 'o %s týždne', many: 'o %s týždňa', other: 'o %s týždňov' },
    d: { one: 'o %s deň', few: 'o %s dni', many: 'o %s dňa', other: 'o %s dní' },
    h: { one: 'o %s hodinu', few: 'o %s hodiny', many: 'o %s hodiny', other: 'o %s hodín' },
    m: { one: 'o %s minútu', few: 'o %s minúty', many: 'o %s minúty', other: 'o %s minút' },
    s: { one: 'o %s sekundu', few: 'o %s sekundy', many: 'o %s sekundy', other: 'o %s sekúnd' },
  },
  abbr: {
    y: { one: '%s r.', few: '%s r.', many: '%s r.', other: '%s r.' },
    M: { one: '%s mes.', few: '%s mes.', many: '%s mes.', other: '%s mes.' },
    w: { one: '%s týž.', few: '%s týž.', many: '%s týž.', other: '%s týž.' },
    d: { one: '%s deň', few: '%s dni', many: '%s dňa', other: '%s dní' },
    h: { one: '%s h', few: '%s h', many: '%s h', other: '%s h' },
    m: { one: '%s min', few: '%s min', many: '%s min', other: '%s min' },
    s: { one: '%s s', few: '%s s', many: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s rok', few: '%s roky', many: '%s roka', other: '%s rokov' },
    M: { one: '%s mesiac', few: '%s mesiace', many: '%s mesiaca', other: '%s mesiacov' },
    w: { one: '%s týždeň', few: '%s týždne', many: '%s týždňa', other: '%s týždňov' },
    d: { one: '%s deň', few: '%s dni', many: '%s dňa', other: '%s dní' },
    h: { one: '%s hodina', few: '%s hodiny', many: '%s hodiny', other: '%s hodín' },
    m: { one: '%s minúta', few: '%s minúty', many: '%s minúty', other: '%s minút' },
    s: { one: '%s sekunda', few: '%s sekundy', many: '%s sekundy', other: '%s sekúnd' },
  },
  justNow: 'Práve teraz',
  yesterday: 'Včera',
  today: 'Dnes',
  tomorrow: 'Zajtra',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. M. YYYY' },
    dl: { start: 'D.', end: 'D. M.' },
    y: { start: 'D. M. YYYY', end: 'D. M. YYYY' },
    'y-1': { start: 'D. M.', end: 'D. M. YYYY' },
    m: { start: 'D. M.', end: 'D. M.' },
    'm-1': { start: 'D.', end: 'D. M. YYYY' },
    d: { start: 'D.', end: 'D. M.' },
    Y: { start: 'ddd D. M. YYYY', end: 'ddd D. M. YYYY' },
    'Y-1': { start: 'ddd D. M.', end: 'ddd D. M. YYYY' },
    M: { start: 'ddd D. M.', end: 'ddd D. M.' },
    D: { start: 'ddd D.', end: 'ddd D. M.' },
    yt: { start: 'D. M. YYYY, H:mm', end: 'D. M. YYYY, H:mm' },
    mt: { start: 'D. M., H:mm', end: 'D. M., H:mm' },
    dt: { start: 'D. M., H:mm', end: 'D. M., H:mm' },
    t: { start: 'H:mm', end: 'H:mm' },
    'yt+to': { start: 'D. M. YYYY, H:mm', end: 'D. M. YYYY, H:mm ([GMT]Z)' },
    'mt+to': { start: 'D. M., H:mm', end: 'D. M., H:mm ([GMT]Z)' },
    'dt+to': { start: 'D. M., H:mm', end: 'D. M., H:mm ([GMT]Z)' },
    't+to': { start: 'H:mm', end: 'H:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'sk';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'dop.' : 'dop.';
    } else {
      return isLowerCase ? 'pop.' : 'pop.';
    }
  },
};
